import {
  IsString, IsNotEmpty, IsEmail,
} from 'class-validator';

export class AccountDTO {
  @IsString()
  @IsNotEmpty()
  public firstname!: string;

  @IsString()
  @IsNotEmpty()
  public lastname!: string;

  @IsEmail()
  public email!: string;
}
